module.exports = __webpack_public_path__ + "60238648c7bcb110c7fc5c8cc42b989c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/partners/images/banner_p.png
// module id = 954
// module chunks = 3